import React from 'react';

import CleanBanner from '@/components/corporate/CleanBanner';
import StructureImage from '@/assets/imgs/home/qufa_structure.png';
import ExampleImage from '@/assets/imgs/home/qufa_ex.png';

const caps = [
  { title: '데이터 프로파일링', desc: '데이터의 구조·분포·품질을 자동으로 진단합니다.' },
  { title: '표준 용어 검증', desc: '표준 용어 사전과 대조해 일관성을 점검합니다.' },
  { title: '이상치 감지·보정', desc: '이상치를 탐지하고 보정해 데이터 품질을 끌어올립니다.' },
  { title: '데이터 공정성 분석', desc: '데이터의 편향을 분석해 공정성을 진단합니다.' },
  { title: 'AI 기반 공정화', desc: 'AI 모델을 활용해 데이터를 공정화합니다.' },
  { title: '단계별 시각화', desc: '단계별 결과를 GUI 환경에서 직관적으로 시각화합니다.' },
];

export default function QufaStudio() {
  return (
    <div className="cp">
      <CleanBanner eyebrow="PRODUCT" title="QuFa Studio" desc="쿠파 스튜디오 · 데이터 품질·공정성 관리 통합 솔루션" />

      {/* 소개 — 상단 중앙 텍스트 + 좌(구조도) / 우(화면 예시) */}
      <section className="cp-section">
        <div className="cp__container">
          <div className="cp-head" style={{ maxWidth: 820, margin: '0 auto 52px' }}>
            <div className="cp-head__eyebrow">WHAT IS IT</div>
            <h2 className="cp-head__title" style={{ marginBottom: 18 }}>
              QuFa Studio란?
            </h2>
            <p style={{ margin: 0, fontSize: 18, lineHeight: 1.75, color: '#565b70' }}>
              데이터 <b className="cp-emph">품질</b>과 <b className="cp-emph">공정성</b>을 함께 관리하는 통합
              솔루션입니다. 프로파일링부터 공정성 분석까지,
              <br />
              단계별 시각화로 <b className="cp-emph">데이터 품질 진단</b>을 돕습니다.
            </p>
          </div>
          <div className="cp-qufa-media">
            <div className="cp-qufa-media__card">
              <div className="cp-qufa-media__frame">
                <img src={StructureImage} alt="QuFa Studio 솔루션 구조" />
              </div>
              <div className="cp-qufa-media__caption">솔루션 구조 (Data Quality &amp; Fairness)</div>
            </div>
            <div className="cp-qufa-media__card">
              <div className="cp-qufa-media__shot">
                <img src={ExampleImage} alt="QuFa Studio 화면 예시" />
              </div>
              <div className="cp-qufa-media__caption">화면 예시</div>
            </div>
          </div>
        </div>
      </section>

      {/* 핵심 역량 */}
      <section className="cp-section cp-section--soft">
        <div className="cp__container">
          <div className="cp-head">
            <div className="cp-head__eyebrow">CAPABILITIES</div>
            <h2 className="cp-head__title">QuFa Studio의 핵심 역량</h2>
          </div>
          <div className="cp-cards cp-cards--3">
            {caps.map((c) => (
              <div key={c.title} className="cp-card">
                <div className="cp-card__diahead">
                  <span className="cp-dot" />
                  <div className="cp-card__title" style={{ marginBottom: 0 }}>
                    {c.title}
                  </div>
                </div>
                <div className="cp-card__desc">{c.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
